import { criticityPill } from "./criticity";

export function showBoolean(value: boolean | undefined): React.ReactNode {
  return value === undefined ? (
    <></>
  ) : value ? (
    criticityPill("OK", "Yes")
  ) : (
    criticityPill(undefined, "No")
  );
}

export function checkPasswordStrength(password: string): {
  score: number;
  level: string;
  valid: boolean;
} {
  if (!password) return { score: 0, level: "Very Low", valid: false };

  if (password.length < 8) return { score: 0, level: "Very Low", valid: false };

  const criteria = {
    length: password.length >= 16,
    hasLowercase: /[a-z]/.test(password),
    hasUppercase: /[A-Z]/.test(password),
    hasNumber: /\d/.test(password),
    hasSpecial: /[^A-Za-z0-9]/.test(password),
    hasBengali: /\p{Script=Bengali}/u.test(password)
  };

  const score = Object.values(criteria).filter(Boolean).length;

  let level = "Low";
  let valid = false;

  if (score >= 3) {
    valid = true;
    level = "Medium";
    if (score >= 4) {
      level = "Strong";
    }
  }

  return {
    score: score,
    level: level,
    valid
  };
}
